import BarsIcon from '../../../assets/icons/bars.svg?react'

export interface CellTitleProps {
  id: string
  sortColumns?: unknown
  children: React.ReactNode
}

export const CellTitle = ({ id, sortColumns, children }: CellTitleProps): JSX.Element => {
  const columns = sortColumns as
    | Array<{ column: { key?: string }; order?: 'ascend' | 'descend' | null }>
    | undefined
  const column = columns?.find(sort => sort.column.key === id)

  return (
    <div className='flex gap-2 items-center justify-between pr-0.5'>
      <div>{children}</div>

      {!column?.order && (
        <BarsIcon className='text-[#b1b1b1] -scale-y-100 translate-y-[1px] shrink-0' />
      )}

      {column && column.order === 'ascend' && (
        <BarsIcon className='text-[#1676ff] -scale-y-100 translate-y-[1px] shrink-0' />
      )}

      {column && column.order === 'descend' && (
        <BarsIcon className='text-[#1676ff] rotate-180 -scale-100 translate-y-[1px] shrink-0' />
      )}
    </div>
  )
}
